/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { OffsetDateTime } from "@freightsimple/time/branded-types";

import { mapValues } from "../runtime";
import type { LineItem } from "./LineItem";
import {
  LineItemFromJSON,
  LineItemFromJSONTyped,
  LineItemToJSON,
  LineItemToJSONTyped,
} from "./LineItem";
import type { Location } from "./Location";
import {
  LocationFromJSON,
  LocationFromJSONTyped,
  LocationToJSON,
  LocationToJSONTyped,
} from "./Location";
import type { QuoteTestScenarioMetadata } from "./QuoteTestScenarioMetadata";
import {
  QuoteTestScenarioMetadataFromJSON,
  QuoteTestScenarioMetadataFromJSONTyped,
  QuoteTestScenarioMetadataToJSON,
  QuoteTestScenarioMetadataToJSONTyped,
} from "./QuoteTestScenarioMetadata";

/**
 *
 * @export
 * @interface QuoteTestScenarioDto
 */
export interface QuoteTestScenarioDto {
  /**
   *
   * @type {string}
   * @memberof QuoteTestScenarioDto
   */
  scenarioId?: string;
  /**
   *
   * @type {string}
   * @memberof QuoteTestScenarioDto
   */
  groupId?: string;
  /**
   *
   * @type {OffsetDateTime}
   * @memberof QuoteTestScenarioDto
   */
  createdAt?: OffsetDateTime;
  /**
   *
   * @type {string}
   * @memberof QuoteTestScenarioDto
   */
  createdBy?: string;
  /**
   *
   * @type {string}
   * @memberof QuoteTestScenarioDto
   */
  title?: string;
  /**
   *
   * @type {string}
   * @memberof QuoteTestScenarioDto
   */
  description?: string;
  /**
   *
   * @type {Array<LineItem>}
   * @memberof QuoteTestScenarioDto
   */
  lineItems?: Array<LineItem>;
  /**
   *
   * @type {Location}
   * @memberof QuoteTestScenarioDto
   */
  pickupLocation?: Location;
  /**
   *
   * @type {Location}
   * @memberof QuoteTestScenarioDto
   */
  deliveryLocation?: Location;
  /**
   *
   * @type {string}
   * @memberof QuoteTestScenarioDto
   */
  metadata?: string;
  /**
   *
   * @type {QuoteTestScenarioMetadata}
   * @memberof QuoteTestScenarioDto
   */
  parsedMetadata: QuoteTestScenarioMetadata;
}

/**
 * Check if a given object implements the QuoteTestScenarioDto interface.
 */
export function instanceOfQuoteTestScenarioDto(
  value: object,
): value is QuoteTestScenarioDto {
  if (!("parsedMetadata" in value) || value["parsedMetadata"] === undefined)
    return false;
  return true;
}

export function QuoteTestScenarioDtoFromJSON(json: any): QuoteTestScenarioDto {
  return QuoteTestScenarioDtoFromJSONTyped(json, false);
}

export function QuoteTestScenarioDtoFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): QuoteTestScenarioDto {
  if (json == null) {
    return json;
  }
  return {
    scenarioId: json["scenarioId"] == null ? undefined : json["scenarioId"],
    groupId: json["groupId"] == null ? undefined : json["groupId"],
    createdAt: json["createdAt"] == null ? undefined : json["createdAt"],
    createdBy: json["createdBy"] == null ? undefined : json["createdBy"],
    title: json["title"] == null ? undefined : json["title"],
    description: json["description"] == null ? undefined : json["description"],
    lineItems:
      json["lineItems"] == null
        ? undefined
        : (json["lineItems"] as Array<any>).map(LineItemFromJSON),
    pickupLocation:
      json["pickupLocation"] == null
        ? undefined
        : LocationFromJSON(json["pickupLocation"]),
    deliveryLocation:
      json["deliveryLocation"] == null
        ? undefined
        : LocationFromJSON(json["deliveryLocation"]),
    metadata: json["metadata"] == null ? undefined : json["metadata"],
    parsedMetadata: QuoteTestScenarioMetadataFromJSON(json["parsedMetadata"]),
  };
}

export function QuoteTestScenarioDtoToJSON(json: any): QuoteTestScenarioDto {
  return QuoteTestScenarioDtoToJSONTyped(json, false);
}

export function QuoteTestScenarioDtoToJSONTyped(
  value?: QuoteTestScenarioDto | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    scenarioId: value["scenarioId"],
    groupId: value["groupId"],
    createdAt: value["createdAt"],
    createdBy: value["createdBy"],
    title: value["title"],
    description: value["description"],
    lineItems:
      value["lineItems"] == null
        ? undefined
        : (value["lineItems"] as Array<any>).map(LineItemToJSON),
    pickupLocation: LocationToJSON(value["pickupLocation"]),
    deliveryLocation: LocationToJSON(value["deliveryLocation"]),
    metadata: value["metadata"],
    parsedMetadata: QuoteTestScenarioMetadataToJSON(value["parsedMetadata"]),
  };
}
